import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsFillNodePlusFill, BsFillXCircleFill } from "react-icons/bs";
import TextInput from "../../../../../../Components/UI/Form/TextInput";
import SelectInput from "../../../../../../Components/UI/Form/SelectInput";
// Tax rate is a multi-select; still MUI until a token-based multi-select exists.
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const CostFulfilmentCard = ({
  totalWeight,
  onTotalProductCount,
  onTotalWeightChange,
  totalProductPrice,
  selectedProducts,
  setSelectedProducts,
}) => {
  const { t } = useTranslation("products");
  // console.log(totalProductPrice + "old");
  const [costTypeDrop, setCostTypeDrop] = useState("");
  const [totalWeightFulfillment, setTotalWeightFulfillmentKg] = useState(0);
  const [totalWeightFulfillmentLb, setTotalWeightFulfillmentLb] = useState(0);
  const [totalCountFulfillment, setTotalCountFulfillment] = useState(0);
  const [subtotal, setsubtotal] = useState(0);
  const [fulfillmentGST, setFulfillmentGST] = useState(0);
  const [Total, setTotal] = useState(0);
  const [fulfilmentStatusDrop, setFulfilmentStatusDrop] = useState("");
  const [costValue, setCostValue] = useState("");
  const [costList, setCostList] = useState([]);
  const [weightUnit, setWeightUnit] = useState("kg");
  const [additionalWeightkg, setAdditionalWeightkg] = useState(0);
  const [additionalWeightlb, setAdditionalWeightlb] = useState(0);
  const [customOption, setCustomOption] = useState("");
  const [selectedTaxRate, setSelectedTaxRate] = useState(0);
  const [isAdditionalTaxVisible, setIsAdditionalTaxVisible] = useState(false);
  const [selectedTaxRates, setSelectedTaxRates] = useState([]);
  const [selectedTaxOptions, setSelectedTaxOptions] = useState([]);
  const [tierweight, settierweight] = useState();
  const [fulfilmentweight, setfulfilmentweight] = useState();
  const [quantity, setquantity] = useState();
  const [fulfilmenttotal, setfulfilmenttotal] = useState(0);
  const [price, setprice] = useState(0);
  const [taxTotal, settaxTotal] = useState(0);

  const [dropdownOptions, setDropdownOptions] = useState([
    "Additional Fulfilment",
    "Delivery",
    "Remove Fulfilment Fee",
    "Shipping Overcharge",
  ]);
  const [showCustomField, setShowCustomField] = useState(false);
  const [customTaxName, setCustomTaxName] = useState("");
  const [customTaxValue, setCustomTaxValue] = useState("");
  const [taxOptions, setTaxOptions] = useState([
    { name: "PST", value: 1 },
    { name: "GST", value: 5 },
    { name: "QST", value: 10 },
  ]);

  const handleChangeCostTypeDrop = (event) => {
    const selectedOption = event.target.value;
    if (!costList.some((cost) => cost.costType === selectedOption)) {
      setCostTypeDrop(selectedOption);
    } else {
    }
  };

  const handleChangeFulfilmentStatus = (event) => {
    setFulfilmentStatusDrop(event.target.value);
  };

  const handleWeightUnitChange = (event) => {
    setWeightUnit(event.target.value);
    setAdditionalWeightkg(additionalWeightkg);
    setAdditionalWeightlb((additionalWeightkg * 2.24).toFixed(2));
  };

  const handleAddToCart = () => {
    if (costTypeDrop && costValue) {
      const newCost = {
        costType: costTypeDrop,
        costPrice: costValue,
      };

      setCostList([...costList, newCost]);
      setCostTypeDrop("");
      setCostValue("");
      calculateTotalCost();
    }
  };

  const handleCustomTaxAdd = () => {
    if (customTaxName && customTaxValue) {
      const newTaxOption = {
        name: customTaxName,
        value: parseFloat(customTaxValue).toFixed(2),
      };
      setTaxOptions([...taxOptions, newTaxOption]);
      setCustomTaxName("");
      setCustomTaxValue("");
      toggledditionalTaxVisibility();
    }
  };

  const handleTaxRateChange = (event) => {
    const selectedRates = event.target.value;
    let taxes = 0;
    selectedRates.forEach((tax) => {
      taxes += tax;
    });
    settaxTotal(taxes);
    setSelectedTaxRates(selectedRates);
  };

  const calculateOverallTotal = (selectedRates) => {
    let totalWithTaxes = subtotal;
    for (const rate of selectedRates) {
      totalWithTaxes += (subtotal * rate) / 100;
    }
    setTotal(totalWithTaxes.toFixed(2));
  };

  const calculateTotalCost = () => {
    const totalCost = costList.reduce((accumulator, cost) => {
      return accumulator + parseFloat(cost.costPrice);
    }, 0);
    let subTotal = price + totalCost + totalProductPrice + fulfilmenttotal;
    setsubtotal(subTotal);
    let taxtotal = subTotal * (taxTotal / 100);
    setTotal((subTotal + taxtotal).toFixed(2));
    return totalCost;
  };

  const handleCustomOptionChange = (event) => {
    setCustomOption(event.target.value);
  };

  const handleAddCustomOption = () => {
    if (customOption.trim() !== "" && !dropdownOptions.includes(customOption)) {
      setDropdownOptions([...dropdownOptions, customOption]);
      setCustomOption("");
      setShowCustomField(!showCustomField);
    }
  };

  const handleRemoveItem = (index) => {
    const updatedList = [...costList];
    updatedList.splice(index, 1);
    setCostList(updatedList);
  };

  const toggledditionalTaxVisibility = () => {
    setIsAdditionalTaxVisible(!isAdditionalTaxVisible);
  };

  useEffect(() => {
    let tierWeight = 0;
    let fulfilmentWeight = 0;
    let tiertotal = 0;
    let fulfilmentTotal = 0;
    let quantity = 0;

    selectedProducts.forEach((product) => {
      if (product.fulfilmentcost == "") {
        tierWeight += product.weight * product.quantity;
        tiertotal += product.price * product.quantity;
      } else {
        fulfilmentWeight += product.weight * product.quantity;
        fulfilmentTotal += product.fulfilmentcost * product.quantity;
        quantity += product.quantity;
      }
    });
    if (tierWeight < 1) {
      setprice(0);
    } else if (tierWeight >= 1 && tierWeight <= 51) {
      setprice(15);
    } else if (tierWeight >= 52 && tierWeight <= 101) {
      setprice(25);
    } else if (tierWeight >= 102 && tierWeight <= 150) {
      setprice(50);
    } else {
      setprice(100);
    }

    settierweight(parseFloat(tierWeight)+parseFloat(additionalWeightkg));
    setfulfilmentweight(fulfilmentWeight);
    setfulfilmenttotal(fulfilmentTotal);
    setquantity(quantity);
    // console.log(selectedProducts);
    // console.log(additionalWeightkg + "fulfilmentWeight" + tierWeight + "tierWeight");
    // console.log(tiertotal + "tiertotal");
    // console.log(fulfilmentWeight + "fulfilmentWeight");
    // console.log(fulfilmentTotal + "fulfilmentTotal");
  }, [
    selectedProducts,
    totalWeight,
    onTotalWeightChange,
    onTotalProductCount,
    totalProductPrice,
    additionalWeightkg,
  ]);

  useEffect(() => {
    setTotalWeightFulfillmentKg(
      parseFloat(additionalWeightkg) + parseFloat(onTotalWeightChange)
    );
    setTotalWeightFulfillmentLb(
      parseFloat(additionalWeightlb) + parseFloat(onTotalWeightChange * 2.24)
    );
    setTotalCountFulfillment(onTotalProductCount);
    calculateTotalCost();
  }, [
    totalWeight,
    onTotalWeightChange,
    onTotalProductCount,
    totalProductPrice,
    selectedTaxRates,
    taxTotal,
    costList,
  ]);

  return (
    <>
      <div className="paymentShipping__costFulfilment_wrap_main">
        <div className="paymentShipping__costFulfilment_card_wrap">
          <div className="paymentShipping__costFulfilment_header_main">
            <h2>{t("addNew.costFulfilment")} </h2>
          </div>
          <div className="paymentShipping__costFulfilment_body_main">
            <div className="paymentShipping__costFulfilment_fields">
              <div className="paymentShipping__costFulfilment_fields_cost_wrap">
                <div className="paymentShipping__costFulfilment_fields_cost_type">
                  <SelectInput
                    label={t("addNew.costType")}
                    name="costType"
                    value={costTypeDrop}
                    onChange={handleChangeCostTypeDrop}
                    options={dropdownOptions}
                    placeholder=""
                  />
                  <button
                    type="button"
                    className="paymentShipping__costFulfilment_add_more_Btn shrink-0 rounded-md border border-brand bg-brand px-3 py-[7px] text-xs font-semibold text-white transition-colors hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-50"
                    onClick={() => setShowCustomField(!showCustomField)}
                    disabled={costList.some(
                      (cost) => cost.costType === costTypeDrop
                    )}
                  >
                    +
                  </button>
                  {showCustomField && (
                    <div className="paymentShipping__costFulfilment_add_more_panel">
                      <div
                        className="paymentShipping__costFulfilment_add_more_panel_overlay"
                        onClick={() => setShowCustomField(!showCustomField)}
                      ></div>
                      <div className="paymentShipping__costFulfilment_add_more_panel_wrap">
                        <h3>{t("addNew.addCustomCostType")}</h3>
                        <div className="paymentShipping__costFulfilment_add_more_panel_body">
                          <TextInput
                            label={t("addNew.customOption")}
                            name="customOption"
                            value={customOption}
                            onChange={handleCustomOptionChange}
                          />
                          <button
                            type="button"
                            onClick={handleAddCustomOption}
                            className="shrink-0 rounded-md border border-brand bg-brand px-3 py-[7px] text-xs font-semibold text-white transition-colors hover:bg-brand-hover"
                          >
                            {t("common:actions.add")}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="paymentShipping__costFulfilment_fields_cost_input">
                  <TextInput
                    label={t("addNew.costPrice")}
                    name="costValue"
                    value={costValue}
                    onChange={(e) => setCostValue(e.target.value)}
                    prefix="$"
                    className="paymentShipping__costFulfilment_cost_value"
                  />
                </div>
                <div className="paymentShipping__costFulfilment_fields_cost_add_btn">
                  <button
                    type="button"
                    aria-label={t("addNew.addCost")}
                    onClick={handleAddToCart}
                    className="rounded-md border border-brand bg-brand px-3 py-[7px] text-xs font-semibold text-white transition-colors hover:bg-brand-hover"
                  >
                    {t("common:actions.add")}
                  </button>
                </div>
              </div>
              <div className="fulfilment_status_addional_weight_wrap">
                <div className="fulfilment_status_field_field">
                  <div className="fulfilment_status_field_dropdown">
                    <SelectInput
                      label={t("addNew.status")}
                      name="fulfilmentStatus"
                      value={fulfilmentStatusDrop}
                      onChange={handleChangeFulfilmentStatus}
                      placeholder=""
                      options={[
                        { value: 10, label: t("addNew.statuses.paid") },
                        { value: 20, label: t("addNew.statuses.unpaid") },
                        { value: 30, label: t("addNew.statuses.disputed") },
                        { value: 40, label: t("addNew.statuses.disputedWon") },
                        { value: 50, label: t("addNew.statuses.disputedLost") },
                        { value: 60, label: t("addNew.statuses.inProcess") },
                        { value: 70, label: t("addNew.statuses.pending") },
                      ]}
                    />
                  </div>
                  <div className="paymentShipping__costFulfilment_fields_tax_rate">
                    <FormControl variant="outlined">
                      <InputLabel id="paymentShipping__costFulfilment_tax_rate">
                        {t("addNew.taxRate")}
                      </InputLabel>
                      <Select
                        labelId="paymentShipping__costFulfilment_tax_rate"
                        id="paymentShipping__costFulfilment_tax_rate"
                        value={selectedTaxRates}
                        label={t("addNew.taxRate")}
                        onChange={handleTaxRateChange}
                        style={{ height: "45px" }}
                        multiple
                      >
                        {taxOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div
                      className="toggle__additional_Tax_btn"
                      onClick={toggledditionalTaxVisibility}
                    >
                      {" "}
                      +{" "}
                    </div>
                    {isAdditionalTaxVisible && (
                      <div className="additional__tax_popup_wrap">
                        <div
                          className="additional__tax_popup_overlay"
                          onClick={toggledditionalTaxVisibility}
                        ></div>
                        <div className="additional__tax_popup_fields">
                          <h3>{t("addNew.addCustomTax")}</h3>
                          <div className="additional__tax_popup_body">
                            <TextInput
                              label={t("addNew.customTaxName")}
                              name="customTaxName"
                              value={customTaxName}
                              onChange={(e) => setCustomTaxName(e.target.value)}
                            />
                            <TextInput
                              label={t("addNew.customTaxValue")}
                              name="customTaxValue"
                              value={customTaxValue}
                              onChange={(e) =>
                                setCustomTaxValue(e.target.value)
                              }
                            />
                            <button
                              type="button"
                              onClick={handleCustomTaxAdd}
                              className="shrink-0 rounded-md border border-brand bg-brand px-3 py-[7px] text-xs font-semibold text-white transition-colors hover:bg-brand-hover"
                            >
                              {t("common:actions.add")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="fulfilment_status_additional_weight_wrapper">
                <div className="fulfilment_status_additional_weight_field">
                  {weightUnit === "kg" ? (
                    <TextInput
                      label={t("addNew.additionalWeightKg")}
                      name="additionalWeightkg"
                      value={additionalWeightkg}
                      onChange={(e) => setAdditionalWeightkg(e.target.value)}
                      prefix="kg"
                      className="paymentShipping__additional_weight_kg"
                    />
                  ) : (
                    <TextInput
                      label={t("addNew.additionalWeightLb")}
                      name="additionalWeightlb"
                      value={additionalWeightlb}
                      onChange={(e) => setAdditionalWeightlb(e.target.value)}
                      prefix="lb"
                      disabled
                      className="paymentShipping__additional_weight_lb"
                    />
                  )}
                </div>
                <div className="fulfilment_status_additional_weight_btn">
                  <div
                    role="group"
                    aria-label={t("addNew.weightUnit")}
                    className="inline-flex overflow-hidden rounded-md border border-ui-border"
                  >
                    {["kg", "lb"].map((unit) => (
                      <button
                        key={unit}
                        type="button"
                        aria-pressed={weightUnit === unit}
                        onClick={() =>
                          handleWeightUnitChange({ target: { value: unit } })
                        }
                        className={`custom_button_Unit px-3 py-[7px] text-xs font-medium transition-colors ${
                          weightUnit === unit
                            ? "bg-brand-light text-brand"
                            : "bg-ui-surface text-ui-text-muted hover:text-brand"
                        }`}
                      >
                        {unit}
                      </button>
                    ))}
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div className="paymentShipping__fulfillment_data_wrap">
                <strong>{t("addNew.fulfilmentCost")}{" "}</strong> 
              <div className="paymentShipping__fulfillment_delivery_nogst_total">
                <label>{t("addNew.weightLabel", { weight: tierweight })}</label>
                <span>{price} CAD </span>
              </div>
              <div className="paymentShipping__fulfillment_delivery_nogst_total">
                <label>{t("addNew.itemQuantity", { quantity })}</label>
                <span>{fulfilmenttotal} CAD </span>
              </div>
              <div className="paymentShipping__fulfillment_delivery_nogst_total">
                <label>{t("addNew.totalFulfilmentCost")} </label>
                <span>{price + fulfilmenttotal} CAD </span>
              </div>
              <div className="paymentShipping__fulfillment_delivery_wrap">
                <div className="paymentShipping__fulfillment_cost_list">
                  <ul>
                    {costList.map((cost, index) => (
                      <li
                        className="paymentShipping__fulfillment_cost_list_li"
                        key={index}
                      >
                        <div className="paymentShipping__fulfillment_cost_list_title">
                          {cost.costType}
                        </div>
                        <div className="paymentShipping__fulfillment_cost_list_value">
                          ${cost.costPrice}
                        </div>
                        <button
                          className="paymentShipping__fulfillment_cost_list_remove"
                          onClick={() => handleRemoveItem(index)}
                        >
                          <BsFillXCircleFill />
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="paymentShipping__fulfillment_delivery_nogst_total">
                  <label>{t("addNew.totalProductPrice")}</label>
                  <span>{totalProductPrice } CAD </span>
                </div>
                <div className="paymentShipping__fulfillment_delivery_nogst_total">
                  <label>{t("addNew.subTotal")}</label>
                  <span>{subtotal} CAD </span>
                </div>
                <div className="paymentShipping__fulfillment_delivery_gst">
                  {selectedTaxRates.map((rate, index) => {
                    const taxOption = taxOptions.find(
                      (option) => option.value === rate
                    );
                    return (
                      <label key={index}>
                        {taxOption.name} @ &nbsp; {taxOption.value} %{" "}
                        <span>{(subtotal * (taxOption.value / 100)).toFixed(2)} CAD </span>
                      </label>
                    );
                  })}
                </div>
                <div className="paymentShipping__fulfillment_delivery_total_overall">
                  <label>{t("addNew.total")} </label>
                  <span>{Total} CAD </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CostFulfilmentCard;
